<template>
  <div>
    <div
      v-if="shouldPaginate"
      class="d-flex justify-content-end employee__filtration"
    >
      <PaginationComponent
        :meta="meta"
      />
    </div>
    <div class="container container--employee artworks">
      <div class="row table__wrapper">
        <table class="dashboard__table">
          <MainTableHead />
          <MainTableBody :internetAuctions="internetAuctions" />
        </table>
      </div>
    </div>
    <div class="d-flex justify-content-end employee__filtration">
      <PaginationComponent
        :meta="meta"
        scrollPageToUp
      />
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import PaginationComponent from '@/shared/components/pagination';
  import Loader from '@/shared/components/loader';
  import MainTableHead from './table/main_table_head';
  import MainTableBody from './table/main_table_body';

  export default {
    name: 'Auctions',
    components: {
      PaginationComponent,
      Loader,
      MainTableHead,
      MainTableBody,
    },
    watch: {
      newPage(pageNumber) {
        if (pageNumber) {
          this.fetchAuctions(pageNumber);
        }
      },
    },
    methods: {
      ...mapActions(['fetchAuctions']),
    },
    computed: {
      ...mapState([
        'internetAuctions',
        'meta',
        'newPage',
      ]),
      shouldPaginate() {
        return this.meta && this.meta.total_pages !== 1;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees_orders_panel/components/auctions.vue?540180d9